import { SelectOption } from '../../classes'

export enum AUTHORIZATION_PROCEDURE_STATUS {
  APPROVED = 'A',
  DENIED = 'D',
  PENDING = 'P',
  CANCELLED = 'C',
  NOT_REQUIRED = 'NR',
}

export const AuthorizationProcedureStatuses: SelectOption<AUTHORIZATION_PROCEDURE_STATUS>[] = [
  {
    value: AUTHORIZATION_PROCEDURE_STATUS.APPROVED,
    viewValue: 'statuses.authorization-procedures.A',
  },
  {
    value: AUTHORIZATION_PROCEDURE_STATUS.DENIED,
    viewValue: 'statuses.authorization-procedures.D',
  },
  {
    value: AUTHORIZATION_PROCEDURE_STATUS.PENDING,
    viewValue: 'statuses.authorization-procedures.P',
  },
  {
    value: AUTHORIZATION_PROCEDURE_STATUS.CANCELLED,
    viewValue: 'statuses.authorization-procedures.C',
  },
  {
    value: AUTHORIZATION_PROCEDURE_STATUS.NOT_REQUIRED,
    viewValue: 'statuses.authorization-procedures.NR',
  },
]
